import { useContext } from "react";
import { ScreenVisibilityContext } from "./ScreenVisibilityContext";

export function useVisibleOnScreen() {
    return useContext(ScreenVisibilityContext);
}
